export const notificationPopupStyle = {
  wrapper: {
    padding: '24px',
    width: '373px',
    height: '100%',
  },

  link: {
    '&:first-letter': {
      textTransform: 'uppercase',
    },
    color: 'var(--primary-500)',
    fontWeight: 'bold',
    fontSize: '16px',
    marginTop: '16px',
    paddingBottom: '24px',
    display: 'block',
    marginLeft: 'auto',
  },
  button: {
    width: 'fit-content',
    '&.Mui-disabled svg path': {
      stroke: 'var(--primary-200) !important',
    },
  },
  wrapperTitle: {
    height: '32px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {},
  tabsWrapper: {marginTop: '16px'},
  badgeIcon: {
    '& .MuiBadge-badge': {
      backgroundColor: 'var(--error-500)',
      marginLeft: '8px',
      padding: '4px 4px',
      borderRadius: '50px',
    },
  },
  tabs: {
    '.MuiTab-root': {
      width: '50%',
      maxWidth: 'initial',

      h6: {
        color: 'var(--neutral-300)',
      },

      '&:hover h6': {
        color: '3px solid var(--primary-500)',
      },
    },

    '&.MuiTabs-root .MuiTab-root.Mui-selected': {
      borderBottom: '3px solid var(--primary-500)',

      '&:hover': {
        borderBottom: '3px solid var(--primary-500)',
      },

      h6: {
        color: 'var(--primary-900)',
        paddingBottom: '-5PXpx',
      },
    },
  },
  wrapperList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    paddingTop: '16px',
    //padding: '24px',
  },

  group: {
    color: 'var(--neutral-300)',
    fontSize: '12px',
    marginBottom: '8px',
  },
  groupWrapper: {
    paddingLeft: '36px',
  },
  iconWrapper: {
    whiteSpace: 'nowrap',
  },
};
